module.exports = __webpack_public_path__ + "img/double-arrow-bottom.1532a69.svg?v=1764327952164";